import Vue from 'vue'
import VueRouter from 'vue-router'
import Step1 from '../views/Step1.vue'
import Step2 from '../views/Step2.vue'
import Step2Part2 from '../views/Step2Part2.vue'
import Step2Part3 from '../views/Step2Part3.vue'
import Step2Part4 from '../views/Step2Part4.vue'
import Step3 from '../views/Step3.vue'
import Step4 from '../views/Step4.vue'
import Error from '../views/Error.vue'
import AdminAddUser from '../views/AdminAddUser.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'step1',
    component: Step1
  },
  {
    path: '/step-2',
    name: 'step2',
    component: Step2
  },
  {
    path: '/step-2-part-2',
    name: 'step2part2',
    component: Step2Part2
  },
  {
    path: '/step-2-part-3',
    name: 'step2part3',
    component: Step2Part3
  },
  {
    path: '/step-2-part-4',
    name: 'step2part4',
    component: Step2Part4
  },
  {
    path: '/step-3',
    name: 'step3',
    component: Step3
  },
  {
    path: '/finished',
    name: 'step4',
    component: Step4
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/admin-add-dashboard-user',
    name: 'adminAddUser',
    component: AdminAddUser
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
